$ = require 'jquery'
ApiAjax = require 'network/api-ajax'
Keys = require 'data/keys'
View = require 'view'
template = require 'views/templates/org_prefs_restrict_invites'
templates = require 'views/internal/templates'
Util = require 'lib/util'

module.exports = class OrganizationRestrictInvitesView extends View
  viewTitleKey: 'org membership restrictions'

  initialize: ->
    @listenTo @model, 'change:prefs', @frameDebounce @renderRestrictions

  events:
    'click .js-form-submit-input': 'addRestriction'
    'submit .js-form': 'addRestriction'
    'click .js-restricted-address': 'removeRestriction'

  render: ->

    @$el.html(template({
      hasRestrictions: @model.get('prefs').orgInviteRestrict?.length > 0
    }))
    @renderRestrictions()

    @

  renderRestrictions: ->
    $list = @$('.js-list').empty()

    if @model.get('prefs').orgInviteRestrict?.length > 0
      for restriction in @model.get('prefs').orgInviteRestrict

        $list.append(
          templates.fill(
            'org_pref_restriction',
            { restriction }
          )
        )

      @$('.js-restriction-list').show()

    else
      @$('.js-restriction-list').hide()

  addRestriction: (e) ->
    Util.stop(e)

    restriction = @$('.js-input-restricted').val()

    if /// ^@ ///.test(restriction)
      restriction = "*#{restriction}"
    else if (restriction.indexOf('@') == -1) && (restriction.indexOf('.') > 0)
      restriction = "*@#{restriction}"

    @$('.js-loading').removeClass('hide')

    # Temporary setter until setPref is migrated to the new api
    ApiAjax
      url: "/1/organizations/#{ @model.id }/prefs/orgInviteRestrict"
      type: 'put'
      data: { value: restriction }
      dataType: 'json'
      success: =>
        @$('.js-input-restricted').val("").select().focus()
        @$('.js-loading').addClass('hide')
        @$('.js-errors').hide()
      error: (data) =>
        @$('.js-loading').addClass('hide')
        @$('.js-errors').text(data.responseText).show()

  removeRestriction: (e) ->
    restriction = $(e.target).closest('a').attr('data-pattern')
    $(e.target).closest('li').remove() # make it LOOK like it's disappearing fast

    ApiAjax
      url: "/1/organizations/#{ @model.id }/prefs/orgInviteRestrict"
      type: 'delete'
      data: { value: restriction }
      dataType: 'json'
      success: =>
        @$('.js-input-restricted').select().focus()
        @$('.js-errors').hide()

  enableSelfJoin: (e) ->
    @model.changeSlackSelfJoin(true)

  disableSelfJoin: (e) ->
    @model.changeSlackSelfJoin(false)



// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-restrict-invites-view.coffee